<template>
    <FullFillBox
        :pageID="1015"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('stock_take_log') }}</h4>
        <hr>
        <div class="row">
            <div class="col-lg-10">
                <div class="row">
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_start') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="start-time"
                                       v-model="startDate"
                                       min="2022-11-01T00:00"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_end') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="end-time"
                                       v-model="endDate"
                                       min="2022-11-01T00:00"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-primary" @click="resetTimeFilter">{{ $t('common_reset') }}</button>
                    </div>

                </div>
            </div>
            <div class="col-lg-2">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="key">{{ $t('table_key') }}</option>
                    <option value="loc">{{ $t('inventory_table_gp_loc') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                </select>
            </div>
        </div>
        <hr>
        <div ref="tabulatorTableUse"></div>
    </FullFillBox>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "StockTakeLogView",
    components: {
        FullFillBox,
    },
    data(){
        return{
            permissionDetails: {},
            groupBy: 'no',

            startDate: '',
            endDate: '',
        }
    },
    methods: {
        resetTimeFilter(){
            this.startDate = ""
            this.endDate = ""
            this.getBackendData()
        },
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.tabulator.setGroupBy("")
                this.tabulator.setSort("scanDateTime", "desc");
            }else if(this.groupBy === "key"){
                this.tabulator.setGroupBy("stockTakeName")
                this.tabulator.setSort("scanDateTime", "desc");
            }else if(this.groupBy === "outCode"){
                this.tabulator.setGroupBy("outCode")
                this.tabulator.setSort("outCode", "asc");
            }else if(this.groupBy === "loc"){
                this.tabulator.setGroupBy("location")
                this.tabulator.setSort("location", "asc");
            }
            this.tabulator.redraw()
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            let extraPath = ""
            if(this.startDate){
                extraPath += `?start=${this.startDate}`
            }
            if(this.endDate){
                if(extraPath.length > 4){
                    extraPath += `&end=${this.endDate}`
                }else{
                    extraPath += `?end=${this.endDate}`
                }
            }
            await this.$mainApi.get(`api/stock-take/stock-take-log${extraPath}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.mainData = response.data.details
                        this.tabulator.setData(this.mainData)
                        this.tabulator.redraw()
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('stock_take_log')
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            height: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            data: [],
            columns: [
                {formatter: 'rownum', width: 50, minWidth: 50, maxWidth: 50, responsive: 0},
                {
                    responsive:5, widthGrow:1,
                    title: this.$t('table_stock_take'),
                    field: "stockTakeName",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, widthGrow:1.5,
                    title: this.$t('table_create_date'),
                    field: "scanDateTime",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, widthGrow:1.5,
                    title: "lastUpdateTime",
                    field: "lastUpdateTime",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, widthGrow:1,
                    title: this.$t('table_show_name'),
                    field: "show_name",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    minWidth: 100, responsive:0, widthGrow:1,
                    title: this.$t('table_qty'),
                    field: "scanQty",
                    sorter: "string",
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:3, widthGrow:2,
                    title: this.$t('table_remarks'),
                    field: "remarks",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:1, responsive:3,
                    title: this.$t('table_key_remarks'),
                    field: "keyRemarks", visible: false,
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:3, widthGrow:1,
                    title: this.$t('table_location'),
                    field: "location",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    minWidth:250, responsive:0,
                    title: this.$t('product_outCode_short'),
                    field: "outCode",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    minWidth:300, responsive:5, formatter: 'textarea',
                    title: this.$t('product_product_en'),
                    field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
            ],
        })
        this.getBackendData()
    },
}
</script>

<style scoped>

</style>
